import React, {Component} from 'react'

import styled from '@emotion/styled'
import sv from '../styles/styles'
import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'
import {alertActions, sourceActions} from "../_actions";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import VideoThumbnail from '../components/VideoThumbnail'
import {Header} from "../components/Header";
import {AnimatedLoader, Container, IsVerifying, StyledMedia} from "../styles/CommonStyler"
import Footer from "../components/Footer";
import {isMobileOnly} from "react-device-detect";
import {__isAvailable, __isKeyAvailable, orderHelper} from "../_helpers";
import AuthError from "../components/AuthError";
import {alertActionTypes} from "../_constants";

// STYLE ##########################################################

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
`;

const Label = styled(`span`)`
  ${sv.label};
  color: ${sv.colors.darkGray};
  margin: 8px 0;
  text-transform: none;
`;

const VideoName = styled(`div`)`
  ${sv.h3};
  padding: 5px 0;
`;

const Disclosure = styled(`div`)`
  font-size: 14px;
  font-style: italic;
`;

const UsageData = styled(`div`)`
  margin: 24px 0;
`;

const ProgressBar = styled(`div`)`
  position: relative;
  height: 8px;
  width: 100%;
  border-radius: 4px;
  background: ${sv.colors.subtleGrey};
`;

const Progress = styled(`div`)`
  position: absolute;
  left: 0;
  top: 0;
  height: 8px;
  width: ${props => props.progress}%;
  border-radius: 4px 0 0 4px;
  background: ${props => props.backgroundColor};
`;

// COMPONENT ##########################################################

class OrderConfirmation extends Component {

    constructor(props) {
        super(props);

        this.handleOrder = this.handleOrder.bind(this);
        this.resetOrder = this.resetOrder.bind(this);
    }

    state = {
        title: '',
        url: '',
        isCancelled: false,
    };

    handleOrder(e) {
        e.preventDefault();
        const {t, order} = this.props;

        // check if basic source parameters are available
        if(order && order.source && __isAvailable(order.source.info)) {
            const {info, integration, hosted=false} = order.source;
            let newSource = {
                'title': info.title,
                'probeUri': info.validatedUri,
                'hosted' : hosted,
            };
            // if integration information are available then add it to sources
            newSource = ( __isAvailable(integration) )
                            ? {...newSource, integration}
                            : newSource;

            this.orderGist(newSource);
        } else {
            this.props.dispatchCorruptOrder({"errorMsg": t("Sorry something is wrong, please restart the order.")});
        }
    }

    resetOrder(e) {
        e.preventDefault();
        this.setState({'url': '', 'isCancelled': true});

        const {order} = this.props;
        let hosting = false, link = "";
        if(__isKeyAvailable(order, "source")) {
            const {info, hosted=false} = order.source;
            if(hosted) {
                link = info.validatedUri;
                hosting = true;
            }
        }
        this.props.resetCurrOrder(hosting, link);
    }

    orderGist(source) {
        this.props.orderGist(source);
    }

    isOrderQuoteReady() {
        const {order} = this.props;
        return __isKeyAvailable(order, "urlVerified")
            && __isKeyAvailable(order, "source", "info")
            && __isKeyAvailable(order, "source", "usage");
    }

    // get order error messages, if any
    getOrderErrorMessage() {
        const {alert, t} = this.props;
        let errorMessage;

        const errorMessageAvailable = alert.type === alertActionTypes.ERROR;            // priority #01
        const orderCorrupted = !this.isOrderQuoteReady() && !this.state.isCancelled;    // priority #02

        if(errorMessageAvailable) {
            errorMessage = alert.message.errorMsg;
        } else if(orderCorrupted) {
            errorMessage = t("Sorry something is wrong, please restart the order.");
        } else {
            errorMessage = "";
        }
        return errorMessage;
    }

    render() {
        const {t, order} = this.props;
        const {source} = order;

        let orderCostText = t('Order Free Gist');
	      let orderLabels = [];
        let usagesDataList = [];
        
        if (this.isOrderQuoteReady()) {   // when the order quote is ready
            const usagesSummaryList = source.usage.summary;
            
            // Prepare Order Labels
            const orderLabelsResponse = orderHelper.getOrderLabels(source);
            for(const labelInstance of orderLabelsResponse) {
                orderLabels.push(
                  <Label key={labelInstance.key}>{labelInstance.value}</Label>
                );
            }
            
            // Prepare Order Usages
            const usagesDataResponse = orderHelper.getUsagesData(usagesSummaryList);
            for(const usageData of usagesDataResponse) {
                usagesDataList.push(
                  <UsageData key={usageData.type}>
                      <ProgressBar>
                          <Progress progress={usageData.postUsage} backgroundColor={sv.colors.cta}/>
                          <Progress progress={usageData.preUsage} backgroundColor={sv.colors.lightOrange}/>
                      </ProgressBar>
                      <Label>
                          {t('Included [unit] - [remainingIncludedUsage] remain from [totalIncludedUsage] total',
                            {
                                unit: usageData.label.unit,
                                remainingIncludedUsage: usageData.label.remaining,
                                totalIncludedUsage: usageData.label.total
                            }
                          )}
                      </Label>
                  </UsageData>
                )
            }
            
            // Prepare Order Cost Text
            const cost = orderHelper.getOrderCost(usagesSummaryList);
            if (cost > 0) {     // if there is some cost involved
                const formattedPrice = orderHelper.getFormattedPrice(cost);
                orderCostText = t('Order Gist for', {amount: formattedPrice});
            }
        }

        const errorMessage = this.getOrderErrorMessage();

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={t('Order a Gist.')}>
                        {/* show error message if any */}
                        { errorMessage !== "" &&
                        <AuthError error={errorMessage}/>
                        }

                        {/* show order quote */}
                        {this.isOrderQuoteReady() &&
                        <>
                            <Label>Verified</Label>
                            <VideoThumbnail height={196} image={source.info.imageUrl} altText={source.info.title}/>
                            <VideoName>{source.info.title}</VideoName>

                            {/* show order labels */}
                            { orderLabels.length > 0 && orderLabels}

                            {/* show usage-data if there are any */}
                            {usagesDataList.length > 0 && usagesDataList}

                            <Disclosure>{t('Ordering a Gist will create a link that you can share with others. Anyone who has this link will be able to view this content.')}</Disclosure>

                            <Actions>
                                {!order.isOrdering &&
                                <AuthButton cancel onClick={this.resetOrder}>{t('Cancel')}</AuthButton>}
                                {!order.isOrdering &&
                                <AuthButton onClick={this.handleOrder}>{orderCostText}</AuthButton>}
                                {order.isOrdering &&
                                <IsVerifying>
                                    <h3>Ordering Gist</h3>
                                    <AnimatedLoader color={sv.colors.cta}/>
                                </IsVerifying>
                                }
                            </Actions>
                        </>
                        }
                    </AuthBase>
                    <Footer/>
                </Container>
            </StyledMedia>
        )
    }

}

function mapStateToProps(state) {
    const {alert, order} = state;
    return {
        alert, order
    };
}

function mapDispatchToProps(dispatch) {
    return {
        orderGist: (source)             => dispatch(sourceActions.orderGist(source)),
        resetCurrOrder: (hosted, link)  => dispatch(sourceActions.resetOrder(hosted, link)),
        dispatchCorruptOrder: (msg)     => dispatch(alertActions.error(msg)),
    };
}

const connectedOrderConfirmation = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation));
export {connectedOrderConfirmation as OrderConfirmation};